import React from 'react'
import HerosectionHeader from '../Componet/Herosection/HerosectionHeader';
import { Container, Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet-async';

const AboutUs = () => {
    return (
        <>
            <Helmet>
                <title>Inspectiver | About Us</title>
                <meta name="description" content="Learn more about Inspectiver, our mission, our experienced inspectors, and how we ensure transparency and confidence in every inspection." />
                <meta name="keywords" content="pre purchase car inspection, pre purchase car inspection near me, Inspectiver, mobile vehicle inspection, about car inspections, vehicle inspection company, Inspectiver mission" />
                <link rel="canonical" href="/about-us" />
            </Helmet>
            <HerosectionHeader name={"About Us"} />
            <div className="page-content">
                <section>
                    <Container>
                        <Row className="justify-content-center text-center">
                            <Col lg="8">
                                <div className="mb-5">
                                    <h2 className="mb-0">
                                        <span className="font-w-4 d-block"></span>We are setting the standard for pre-purchase car inspections
                                    </h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <div className="mt-5 col-md-12 col-lg-12">
                                <div className="d-flex justify-content-between">
                                    <div className="me-3"></div>
                                    <div>
                                        <h5 className="mb-2">About Inspectiver</h5>
                                        <p className="mb-0">Inspectiver is dedicated to ensuring the highest standards of vehicle inspections before purchase.
                                            Our mission is to connect vehicle buyers with certified mechanics who can provide thorough,
                                            reliable, and professional inspections, helping customers make informed decisions. We pride
                                            ourselves on our commitment to quality, transparency, and customer satisfaction.</p>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="mt-5 col-md-12 col-lg-12">
                                <div className="d-flex justify-content-between">
                                    <div className="me-3"></div>
                                    <div>
                                        <h5 className="mb-2">Our Story</h5>
                                        <p className="mb-0">Founded with the vision to revolutionize the car inspection process, Inspectiver bridges the gap
                                            between car buyers and qualified mechanics. Our platform is designed to provide convenience,
                                            trust, and peace of mind, making vehicle buying a hassle-free experience. By partnering with
                                            top-tier mechanics nationwide, we ensure that every vehicle inspection is conducted with the
                                            utmost precision and care.</p>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </section>
                {/* <AboutL3 />
        <TestimonialL1 />
        <BlogL1 />
        <NewsletterL1 /> */}
            </div>
        </>
    )
}

export default AboutUs
